import { useEffect, useState } from "react";
import LogoLockup from "./Logo";

const links = [
    { label: "Manifesto", href: "/manifesto" },
    { label: "Product", href: "/product" },
    { label: "Privacy", href: "/privacy" },
    { label: "Support", href: "/support" },
    { label: "FAQ", href: "/support#faq" },
];

export default function Header() {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            id="top"
            className={`fixed top-0 inset-x-0 z-[1000] bg-[var(--paper)] transition-all duration-500 ${
                scrolled
                    ? "border-b-2 border-[var(--ink)]"
                    : "border-b border-[var(--ink)]/20"
            }`}
            data-testid="site-header"
        >
            <div className="max-w-[1400px] mx-auto px-6 lg:px-10 flex items-center justify-between h-[72px]">
                <LogoLockup size="text-3xl" />
                <nav
                    className="hidden lg:flex items-center gap-8"
                    data-testid="primary-nav"
                >
                    {links.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            className="font-mono text-[11px] uppercase tracking-[0.18em] text-[var(--ink)] hover:text-[var(--hot)] transition-colors relative group"
                            data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                        >
                            {l.label}
                            <span className="absolute -bottom-1 left-0 w-0 h-[2px] bg-[var(--hot)] group-hover:w-full transition-all" />
                        </a>
                    ))}
                </nav>
                <a
                    href="/#waitlist"
                    className="hot-button inline-flex items-center gap-2 px-5 py-2.5 text-xs font-mono uppercase tracking-[0.18em] border-2 border-[var(--ink)]"
                    data-testid="header-cta-join-alpha"
                >
                    Join Alpha
                    <span aria-hidden>↗</span>
                </a>
            </div>
        </header>
    );
}
